import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-764524b8"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "fase-wrapper" };
const _hoisted_2 = { class: "phase-header" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "phase-header-left" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "phase-badge" }, "Fase 1"),
    /*#__PURE__*/ _createElementVNode("div", null, [
        /*#__PURE__*/ _createElementVNode("h2", { class: "phase-title" }, "Emisión de Órdenes a Proveedor"),
        /*#__PURE__*/ _createElementVNode("p", { class: "phase-desc" }, "Importa el CSV enviado al proveedor para registrar la orden en estado de espera.")
    ])
], -1 /* HOISTED */));
const _hoisted_4 = { class: "phase-actions" };
const _hoisted_5 = ["disabled"];
const _hoisted_6 = { class: "phase-grid" };
const _hoisted_7 = { class: "config-panel" };
const _hoisted_8 = { class: "panel-section" };
const _hoisted_9 = { class: "section-icon-title" };
const _hoisted_10 = { class: "section-icon" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "section-title" }, "Archivo de Pedido", -1 /* HOISTED */));
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "section-hint" }, "Suba el CSV con los productos del proveedor.", -1 /* HOISTED */));
const _hoisted_13 = { key: 2 };
const _hoisted_14 = { key: 3 };
const _hoisted_15 = {
    key: 4,
    class: "file-name"
};
const _hoisted_16 = { class: "hint-box" };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Columnas requeridas:"),
    /*#__PURE__*/ _createTextVNode(" CÓDIGO, PROVEEDOR, DESCRIPCIÓN, REFERENCIA, PEDIDO, P. LISTA, DESCUENTO, COSTO DEF.")
], -1 /* HOISTED */));
const _hoisted_18 = {
    key: 0,
    class: "panel-section summary-section"
};
const _hoisted_19 = { class: "section-icon-title" };
const _hoisted_20 = { class: "section-icon green" };
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "section-title" }, "Resumen", -1 /* HOISTED */));
const _hoisted_22 = { class: "stat-row" };
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Líneas detectadas", -1 /* HOISTED */));
const _hoisted_24 = { class: "stat-val" };
const _hoisted_25 = { class: "stat-row" };
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Vinculadas a Surtimotos", -1 /* HOISTED */));
const _hoisted_27 = { class: "stat-val text-success" };
const _hoisted_28 = { class: "stat-row" };
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Sin vincular", -1 /* HOISTED */));
const _hoisted_30 = { class: "stat-val text-warning" };
const _hoisted_31 = { class: "preview-panel" };
const _hoisted_32 = { class: "panel-section h-100" };
const _hoisted_33 = { class: "section-icon-title mb-3" };
const _hoisted_34 = { class: "section-icon purple" };
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "section-title" }, "Vista Previa de Detección", -1 /* HOISTED */));
const _hoisted_36 = {
    key: 0,
    class: "empty-state"
};
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Carga un archivo CSV para visualizar los productos detectados y vincularlos al catálogo.", -1 /* HOISTED */));
const _hoisted_38 = {
    key: 1,
    class: "table-scroll"
};
const _hoisted_39 = { class: "data-table" };
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "CÓDIGO"),
        /*#__PURE__*/ _createElementVNode("th", null, "PROVEEDOR"),
        /*#__PURE__*/ _createElementVNode("th", null, "DESCRIPCIÓN"),
        /*#__PURE__*/ _createElementVNode("th", null, "REFERENCIA"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "PEDIDO"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-end" }, "PRECIO LISTA"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "DESCUENTO"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-end" }, "COSTO DEF."),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-end" }, "TOTAL PEDIDO"),
        /*#__PURE__*/ _createElementVNode("th", { style: { "min-width": "250px" } }, "VINCULAR REPUESTO")
    ])
], -1 /* HOISTED */));
const _hoisted_41 = { class: "code-badge" };
const _hoisted_42 = {
    class: "text-muted",
    style: { "font-size": "0.75rem", "font-weight": "700" }
};
const _hoisted_43 = {
    class: "font-medium",
    style: { "max-width": "250px" }
};
const _hoisted_44 = { class: "ref-badge" };
const _hoisted_45 = { class: "text-center font-bold" };
const _hoisted_46 = { class: "text-end text-muted" };
const _hoisted_47 = { class: "text-center" };
const _hoisted_48 = { class: "discount-pill" };
const _hoisted_49 = { class: "text-end font-bold text-success" };
const _hoisted_50 = {
    class: "text-end font-black",
    style: { "color": "#0f172a" }
};
const _hoisted_51 = { class: "autocomplete-cell" };
const _hoisted_52 = ["onUpdate:modelValue", "onFocus", "onInput", "placeholder"];
const _hoisted_53 = {
    key: 0,
    class: "autocomplete-dropdown"
};
const _hoisted_54 = ["onMousedown"];
const _hoisted_55 = { class: "ref-badge sm" };
const _hoisted_56 = { class: "orders-section" };
const _hoisted_57 = { class: "orders-header" };
const _hoisted_58 = { class: "section-icon-title" };
const _hoisted_59 = { class: "section-icon amber" };
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "section-title" }, "Órdenes en Espera de Recepción", -1 /* HOISTED */));
const _hoisted_61 = {
    key: 0,
    class: "count-badge"
};
const _hoisted_62 = {
    key: 0,
    class: "empty-state-sm"
};
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "No hay órdenes pendientes en este momento.", -1 /* HOISTED */));
const _hoisted_64 = {
    key: 1,
    class: "table-scroll"
};
const _hoisted_65 = { class: "data-table" };
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Código Orden"),
        /*#__PURE__*/ _createElementVNode("th", null, "Fecha Emisión"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "Ítems"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "Estado"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-end" }, "Acción")
    ])
], -1 /* HOISTED */));
const _hoisted_67 = { class: "code-badge primary" };
const _hoisted_68 = { class: "text-muted" };
const _hoisted_69 = { class: "text-center" };
const _hoisted_70 = { class: "count-pill" };
const _hoisted_71 = { class: "text-center" };
const _hoisted_72 = { class: "status-badge warning" };
const _hoisted_73 = { class: "text-end" };
const _hoisted_74 = ["onClick"];
import { ref, computed, onMounted } from 'vue';
import { ComprasService } from '../../../services/ComprasService';
import { RepuestoService } from '../../../services/RepuestoService';
import Swal from 'sweetalert2';
import { DownloadIcon, SaveIcon, LoaderIcon, CloudUploadIcon, CheckCircleIcon, InfoIcon, TrendingUpIcon, ListIcon, FileTextIcon, CheckIcon, SearchIcon, TimerIcon, RefreshCwIcon, TrashIcon } from 'lucide-vue-next';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Fase1Emision',
    setup(__props) {
        const allRepuestos = ref([]);
        const parsedData = ref([]);
        const ordenesEspera = ref([]);
        const file = ref(null);
        const fileInput = ref(null);
        const saving = ref(false);
        const loadingFile = ref(false);
        onMounted(() => {
            loadAllRepuestos();
            loadOrdenesEspera();
        });
        const loadOrdenesEspera = async () => {
            try {
                const res = await ComprasService.getOrdenes();
                ordenesEspera.value = (res || []).filter((o) => o.estadoCompraId === 1);
            }
            catch (e) {
                console.error(e);
            }
        };
        const confirmDelete = (id) => {
            Swal.fire({
                title: '¿Eliminar orden?',
                text: "Esta acción no se puede deshacer.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#ef4444',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        await ComprasService.deleteOrden(id);
                        Swal.fire({ toast: true, position: 'top-end', icon: 'success', title: 'Orden eliminada', showConfirmButton: false, timer: 2000 });
                        loadOrdenesEspera();
                    }
                    catch (e) {
                        Swal.fire('Error', e.message, 'error');
                    }
                }
            });
        };
        const loadAllRepuestos = async () => {
            try {
                allRepuestos.value = await RepuestoService.getLookup();
            }
            catch (e) {
                console.error(e);
            }
        };
        const triggerFileInput = () => fileInput.value?.click();
        const handleFileUpload = (e) => {
            const target = e.target;
            if (target.files && target.files.length > 0) {
                loadingFile.value = true;
                file.value = target.files[0];
                // Small timeout to allow the loader to show up (UX)
                setTimeout(() => {
                    parseCSV(file.value);
                }, 600);
            }
        };
        const parseCSV = (f) => {
            const reader = new FileReader();
            reader.onload = (e) => {
                try {
                    const text = e.target?.result;
                    if (!text) {
                        loadingFile.value = false;
                        return;
                    }
                    const lines = text.split(/\r?\n/);
                    const records = [];
                    // Detect delimiter (comma or semicolon)
                    const firstLine = lines.find(l => l.trim() !== '') || '';
                    if (!firstLine) {
                        Swal.fire('Archivo Vacío', 'El archivo cargado no contiene datos.', 'error');
                        file.value = null;
                        loadingFile.value = false;
                        return;
                    }
                    const delimiter = firstLine.includes(';') ? ';' : ',';
                    const expectedHeaders = ["CÓDIGO", "PROVEEDOR", "DESCRIPCIÓN", "REFERENCIA", "PEDIDO", "PRECIO LISTA", "DESCUENTO", "COSTO DEFINITIVO"];
                    const headerCols = firstLine.split(delimiter).map(c => c.trim().toUpperCase());
                    // Strict Header Validation
                    if (headerCols.length < expectedHeaders.length) {
                        Swal.fire('Formato Inválido', `El archivo debe tener al menos ${expectedHeaders.length} columnas. Detectadas: ${headerCols.length}`, 'error');
                        file.value = null;
                        loadingFile.value = false;
                        return;
                    }
                    const mismatch = [];
                    for (let i = 0; i < expectedHeaders.length; i++) {
                        if (!headerCols[i].includes(expectedHeaders[i].toUpperCase()) && !expectedHeaders[i].toUpperCase().includes(headerCols[i])) {
                            mismatch.push(`Columna ${i + 1} - Esperado: "<strong>${expectedHeaders[i]}</strong>" <br>Encontrado: "${headerCols[i] || 'Vacío'}"`);
                        }
                    }
                    if (mismatch.length > 0) {
                        Swal.fire({
                            title: 'Cabecera Incorrecta',
                            html: `<div style="text-align: left; font-size: 0.85rem;">El formato de las columnas no coincide exactamente con la plantilla esperada:<br><br><ul>${mismatch.map(m => `<li style="margin-bottom:8px;">${m}</li>`).join('')}</ul><br>Revisa que el orden y los nombres sean correctos.</div>`,
                            icon: 'error'
                        });
                        file.value = null;
                        parsedData.value = [];
                        loadingFile.value = false;
                        return;
                    }
                    console.log("Parsing CSV with delimiter:", delimiter);
                    for (let i = 0; i < lines.length; i++) {
                        const line = lines[i].trim();
                        if (!line)
                            continue;
                        const cols = line.split(delimiter);
                        if (cols.length >= expectedHeaders.length) {
                            const codProv = cols[0]?.trim() || '';
                            const marcaProv = cols[1]?.trim() || '';
                            const descProv = cols[2]?.trim() || '';
                            const refProv = cols[3]?.trim() || '';
                            // SKIP HEADER ROWS
                            const isHeader = codProv.toUpperCase().includes('CÓDIGO') ||
                                codProv.toUpperCase().includes('LISTA') ||
                                descProv.toUpperCase().includes('DESCRIPCIÓN') ||
                                marcaProv.toUpperCase().includes('PROVEEDOR');
                            if (isHeader)
                                continue;
                            // Clean and parse numbers
                            const cleanNum = (val) => {
                                if (!val)
                                    return 0;
                                const sanitized = val.replace(/[^\d,.-]/g, '').replace(',', '.');
                                return parseFloat(sanitized) || 0;
                            };
                            const cant = cleanNum(cols[4]?.trim());
                            if (cant === 0 && !codProv)
                                continue;
                            // AUTO-DETECTION LOGIC
                            const match = allRepuestos.value.find(r => (r.referencia && refProv && r.referencia.toLowerCase() === refProv.toLowerCase()) ||
                                (r.referencia && codProv && r.referencia.toLowerCase() === codProv.toLowerCase()));
                            records.push({
                                codigoProveedor: codProv,
                                marcaProveedor: marcaProv,
                                nombreProvisto: descProv,
                                referenciaProvista: refProv,
                                cantidadEsperada: cant,
                                precioBaseOrden: cleanNum(cols[5]?.trim()),
                                descuento1Esperado: cleanNum(cols[6]?.trim()),
                                precioFinalEsperado: cleanNum(cols[7]?.trim()),
                                repuestoId: match ? match.repuestoId : null,
                                repuestoSearch: match ? `${match.referencia} · ${match.nombre}` : '',
                                showList: false,
                                filteredRepuestos: []
                            });
                        }
                    }
                    console.log("Records detected:", records.length);
                    parsedData.value = records;
                }
                catch (err) {
                    console.error(err);
                    Swal.fire('Error', 'Ocurrió un error al procesar el archivo.', 'error');
                }
                finally {
                    loadingFile.value = false;
                }
            };
            reader.readAsText(f);
        };
        const searchRepuestosInRow = (item) => {
            const q = item.repuestoSearch.toLowerCase().trim();
            if (!q) {
                item.filteredRepuestos = [];
                return;
            }
            item.filteredRepuestos = allRepuestos.value.filter((r) => (r.nombre || '').toLowerCase().includes(q) ||
                (r.referencia || '').toLowerCase().includes(q)).slice(0, 8);
        };
        const selectRepuestoForRow = (item, r) => {
            item.repuestoId = r.repuestoId;
            item.repuestoSearch = `${r.referencia} · ${r.nombre}`;
            item.showList = false;
        };
        const isValid = computed(() => parsedData.value.length > 0);
        const downloadTemplate = () => {
            // Using semicolon for better Excel compatibility and comma for decimals
            const csv = "CÓDIGO;PROVEEDOR;DESCRIPCIÓN;REFERENCIA;PEDIDO;PRECIO LISTA;DESCUENTO;COSTO DEFINITIVO\n" +
                "JG-1435;TWOM;AMORTIGUADOR;E-OUTLOOK;150;17,18;35;11,17\n" +
                "3015-0001;TWOM;AMORTIGUADOR B150R;---;60;32,84;35;21,35\n" +
                "2183;TWOM;AMORTIGUADOR GN125;---;30;23,50;35;15,28";
            const blob = new Blob(["\ufeff", csv], { type: 'text/csv;charset=utf-8;' });
            const a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = "Plantilla_Surtimotos_Ordenes.csv";
            a.click();
        };
        const saveOrden = async () => {
            if (!isValid.value)
                return;
            saving.value = true;
            const payload = {
                proveedorId: null,
                detallesParseados: parsedData.value.map(d => ({
                    Codigo: d.codigoProveedor,
                    Proveedor: d.marcaProveedor,
                    Descripcion: d.nombreProvisto,
                    Referencia: d.referenciaProvista,
                    Pedido: d.cantidadEsperada,
                    PrecioLista: d.precioBaseOrden,
                    Descuento: d.descuento1Esperado,
                    CostoDefinitivo: d.precioFinalEsperado,
                    RepuestoEquivalenteId: d.repuestoId
                }))
            };
            try {
                await ComprasService.createOrdenDesdeCsv(payload);
                Swal.fire({ toast: true, position: 'top-end', icon: 'success', title: '¡Orden Creada!', text: 'Lista para recepción en Fase 2.', timer: 3000, showConfirmButton: false, timerProgressBar: true });
                parsedData.value = [];
                file.value = null;
                loadOrdenesEspera();
            }
            catch (error) {
                Swal.fire({ icon: 'error', title: 'Error', text: error.message || "No se pudo crear la orden" });
            }
            finally {
                saving.value = false;
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createCommentVNode(" ── Phase Header ── "),
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("button", {
                            class: "btn-secondary-action",
                            onClick: downloadTemplate
                        }, [
                            _createVNode(_unref(DownloadIcon), { size: 16 }),
                            _createTextVNode(" Descargar Plantilla ")
                        ]),
                        (parsedData.value.length > 0)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn-primary-action",
                                onClick: saveOrden,
                                disabled: !isValid.value || saving.value
                            }, [
                                (!saving.value)
                                    ? (_openBlock(), _createBlock(_unref(SaveIcon), {
                                        key: 0,
                                        size: 16
                                    }))
                                    : (_openBlock(), _createBlock(_unref(LoaderIcon), {
                                        key: 1,
                                        size: 16,
                                        class: "spin"
                                    })),
                                _createTextVNode(" " + _toDisplayString(saving.value ? 'Guardando...' : 'Guardar Orden'), 1 /* TEXT */)
                            ], 8 /* PROPS */, _hoisted_5))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _createCommentVNode(" ── Main Grid ── "),
                _createElementVNode("div", _hoisted_6, [
                    _createCommentVNode(" LEFT: Config Panel "),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _createVNode(_unref(CloudUploadIcon), { size: 18 })
                                ]),
                                _hoisted_11
                            ]),
                            _hoisted_12,
                            _createElementVNode("div", {
                                class: _normalizeClass(["file-drop", { 'file-drop--active': file.value || loadingFile.value }]),
                                onClick: triggerFileInput
                            }, [
                                (loadingFile.value)
                                    ? (_openBlock(), _createBlock(_unref(LoaderIcon), {
                                        key: 0,
                                        size: 32,
                                        class: "spin"
                                    }))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (file.value)
                                            ? (_openBlock(), _createBlock(_unref(CheckCircleIcon), {
                                                key: 0,
                                                size: 32
                                            }))
                                            : (_openBlock(), _createBlock(_unref(CloudUploadIcon), {
                                                key: 1,
                                                size: 32,
                                                class: "text-muted"
                                            }))
                                    ], 64 /* STABLE_FRAGMENT */)),
                                (loadingFile.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Procesando registros..."))
                                    : (!file.value)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Haz clic o arrastra el archivo CSV aquí"))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(file.value.name), 1 /* TEXT */)),
                                _createElementVNode("input", {
                                    type: "file",
                                    ref_key: "fileInput",
                                    ref: fileInput,
                                    onChange: handleFileUpload,
                                    accept: ".csv",
                                    hidden: ""
                                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */)
                            ], 2 /* CLASS */),
                            _createElementVNode("div", _hoisted_16, [
                                _createVNode(_unref(InfoIcon), { size: 16 }),
                                _hoisted_17
                            ])
                        ]),
                        _createCommentVNode(" Summary "),
                        (parsedData.value.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, [
                                        _createVNode(_unref(TrendingUpIcon), { size: 18 })
                                    ]),
                                    _hoisted_21
                                ]),
                                _createElementVNode("div", _hoisted_22, [
                                    _hoisted_23,
                                    _createElementVNode("strong", _hoisted_24, _toDisplayString(parsedData.value.length), 1 /* TEXT */)
                                ]),
                                _createElementVNode("div", _hoisted_25, [
                                    _hoisted_26,
                                    _createElementVNode("strong", _hoisted_27, _toDisplayString(parsedData.value.filter(d => d.repuestoId).length), 1 /* TEXT */)
                                ]),
                                _createElementVNode("div", _hoisted_28, [
                                    _hoisted_29,
                                    _createElementVNode("strong", _hoisted_30, _toDisplayString(parsedData.value.filter(d => !d.repuestoId).length), 1 /* TEXT */)
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _createCommentVNode(" RIGHT: Preview Table "),
                    _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                    _createVNode(_unref(ListIcon), { size: 18 })
                                ]),
                                _hoisted_35
                            ]),
                            (parsedData.value.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                    _createVNode(_unref(FileTextIcon), {
                                        size: 48,
                                        class: "text-muted"
                                    }),
                                    _hoisted_37
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                    _createElementVNode("table", _hoisted_39, [
                                        _hoisted_40,
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parsedData.value, (item, index) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: index,
                                                    class: _normalizeClass({ 'row-linked': item.repuestoId })
                                                }, [
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("span", _hoisted_41, _toDisplayString(item.codigoProveedor || 'N/A'), 1 /* TEXT */)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_42, _toDisplayString(item.marcaProveedor || '---'), 1 /* TEXT */),
                                                    _createElementVNode("td", _hoisted_43, _toDisplayString(item.nombreProvisto), 1 /* TEXT */),
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("span", _hoisted_44, _toDisplayString(item.referenciaProvista || '---'), 1 /* TEXT */)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_45, _toDisplayString(item.cantidadEsperada), 1 /* TEXT */),
                                                    _createElementVNode("td", _hoisted_46, "$" + _toDisplayString(item.precioBaseOrden.toFixed(2)), 1 /* TEXT */),
                                                    _createElementVNode("td", _hoisted_47, [
                                                        _createElementVNode("span", _hoisted_48, _toDisplayString(item.descuento1Esperado) + "%", 1 /* TEXT */)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_49, "$" + _toDisplayString(item.precioFinalEsperado.toFixed(2)), 1 /* TEXT */),
                                                    _createElementVNode("td", _hoisted_50, " $" + _toDisplayString((item.cantidadEsperada * item.precioFinalEsperado).toLocaleString('es-VE', {
                                                        minimumFractionDigits: 2
                                                    })), 1 /* TEXT */),
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("div", _hoisted_51, [
                                                            _createElementVNode("div", {
                                                                class: _normalizeClass(["autocomplete-input-wrap", { linked: item.repuestoId }])
                                                            }, [
                                                                (item.repuestoId)
                                                                    ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                                                                        key: 0,
                                                                        size: 14,
                                                                        class: "text-success"
                                                                    }))
                                                                    : (_openBlock(), _createBlock(_unref(SearchIcon), {
                                                                        key: 1,
                                                                        size: 14,
                                                                        class: "text-muted"
                                                                    })),
                                                                _withDirectives(_createElementVNode("input", {
                                                                    type: "text",
                                                                    class: "autocomplete-input",
                                                                    "onUpdate:modelValue": ($event) => ((item.repuestoSearch) = $event),
                                                                    onFocus: ($event) => (item.showList = true),
                                                                    onInput: ($event) => (searchRepuestosInRow(item)),
                                                                    placeholder: item.repuestoId ? 'Vinculado ✓' : 'Buscar...'
                                                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_52), [
                                                                    [_vModelText, item.repuestoSearch]
                                                                ])
                                                            ], 2 /* CLASS */),
                                                            (item.showList && item.filteredRepuestos && item.filteredRepuestos.length > 0)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.filteredRepuestos, (r) => {
                                                                        return (_openBlock(), _createElementBlock("button", {
                                                                            type: "button",
                                                                            class: "dropdown-item",
                                                                            key: r.repuestoId,
                                                                            onMousedown: _withModifiers(($event) => (selectRepuestoForRow(item, r)), ["prevent"])
                                                                        }, [
                                                                            _createElementVNode("span", _hoisted_55, _toDisplayString(r.referencia), 1 /* TEXT */),
                                                                            _createTextVNode(" " + _toDisplayString(r.nombre), 1 /* TEXT */)
                                                                        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_54));
                                                                    }), 128 /* KEYED_FRAGMENT */))
                                                                ]))
                                                                : _createCommentVNode("v-if", true)
                                                        ])
                                                    ])
                                                ], 2 /* CLASS */));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ])
                                    ])
                                ]))
                        ])
                    ])
                ]),
                _createCommentVNode(" ── Órdenes en Espera ── "),
                _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("div", _hoisted_59, [
                                _createVNode(_unref(TimerIcon), { size: 18 })
                            ]),
                            _hoisted_60,
                            (ordenesEspera.value.length > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(ordenesEspera.value.length), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("button", {
                            class: "btn-icon-sm",
                            onClick: loadOrdenesEspera,
                            title: "Actualizar"
                        }, [
                            _createVNode(_unref(RefreshCwIcon), { size: 16 })
                        ])
                    ]),
                    (ordenesEspera.value.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                            _createVNode(_unref(CheckCircleIcon), {
                                size: 16,
                                class: "text-success"
                            }),
                            _hoisted_63
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_64, [
                            _createElementVNode("table", _hoisted_65, [
                                _hoisted_66,
                                _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ordenesEspera.value, (ord) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                            key: ord.ordenPedidoProveedorId
                                        }, [
                                            _createElementVNode("td", null, [
                                                _createElementVNode("span", _hoisted_67, _toDisplayString(ord.codigoOrden), 1 /* TEXT */)
                                            ]),
                                            _createElementVNode("td", _hoisted_68, _toDisplayString(new Date(ord.fechaEmision).toLocaleDateString('es-VE', {
                                                day: '2-digit', month: 'short', year: 'numeric'
                                            })), 1 /* TEXT */),
                                            _createElementVNode("td", _hoisted_69, [
                                                _createElementVNode("span", _hoisted_70, _toDisplayString(ord.detallesCount || ord.detalles?.length || 0), 1 /* TEXT */)
                                            ]),
                                            _createElementVNode("td", _hoisted_71, [
                                                _createElementVNode("span", _hoisted_72, _toDisplayString(ord.nombreEstado), 1 /* TEXT */)
                                            ]),
                                            _createElementVNode("td", _hoisted_73, [
                                                _createElementVNode("button", {
                                                    class: "btn-danger-sm",
                                                    onClick: ($event) => (confirmDelete(ord.ordenPedidoProveedorId)),
                                                    title: "Eliminar orden"
                                                }, [
                                                    _createVNode(_unref(TrashIcon), { size: 14 })
                                                ], 8 /* PROPS */, _hoisted_74)
                                            ])
                                        ]));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ])
                            ])
                        ]))
                ])
            ]));
        };
    }
});
